import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ApplyForAdmission() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the Google Form immediately when the component mounts
    window.location.href = "https://forms.gle/Rq2BE2mQ9fwrH8gTA";
  }, []); // Empty dependency array ensures this runs only once on mount

  // Return null to render nothing
  return null;
}